import React from 'react';
import { FiCheck, FiX, FiAlertTriangle } from 'react-icons/fi';
import './IdentityCheck.css';

const IdentityCheck = ({ task }) => {
  // Mock Data
  const declared = { name: 'John Doe', idNumber: '9001015009087', dob: '1990-01-01' };
  
  return (
    <div className="identity-check card">
      <div className="card-header">
        <h2>Identity Verification</h2>
      </div>
      <div className="card-body">
        <div className="identity-grid">
          <div className="declared-info">
            <h3>Applicant Declared Data</h3>
            <dl className="data-list">
              <dt>Full Name</dt><dd>{declared.name}</dd>
              <dt>ID Number</dt><dd>{declared.idNumber}</dd>
              <dt>Date of Birth</dt><dd>{declared.dob}</dd>
            </dl>
          </div>
          
          <div className="document-preview">
            <h3>Document Image (Mock)</h3>
            <div className="image-placeholder">
              <span>ID_Document_Front.jpg</span>
            </div>
          </div>
        </div>

        <div className="comparison-results">
          <h3>Verification Checks</h3>
          <ul className="check-list">
            <li className="check-item match">
              <FiCheck className="icon" /> Name matches document
            </li>
            <li className="check-item match">
              <FiCheck className="icon" /> ID number valid length & checksum
            </li>
            <li className="check-item warning">
              <FiAlertTriangle className="icon" /> Visual verification only (No Home Affairs API)
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default IdentityCheck;
